import { useDispatch } from "react-redux";
import type { AppDispatch } from "@app/store";

/**
 * Typed hook for using dispatch
 * Can be used instead of the plain useDispatch,
 * eliminates the need to specify type for useDispatch in every file or component where it is used.
 */
export const useAppDispatch = () => useDispatch<AppDispatch>();
